import moment from 'moment/moment';
import * as _m from '@/models';
import { SpriteSvg } from '@/components/common/SpriteSvg';

type Props = {
  channel_post: _m.ChannelPost;
  from_modal?: boolean;
};

export const Information = ({ channel_post, from_modal = false }: Props) => {
  if (from_modal) {
    return <></>;
  }

  return (
    <>
      {channel_post.term_to && (
        <ul className="types">
          <li>
            <SpriteSvg name={'icon-calendar'} className={'i'} />
            期間限定（〜{moment(channel_post.term_to).format('MM/DD HH:mm')}）
          </li>
        </ul>
      )}
    </>
  );
};
